import * as React from 'react';
import Button from '@mui/material/Button';
import { Row, Form, Col } from 'react-bootstrap';
import FirstName from '../form/FirstName';
import LastName from '../form/LastName';
import City from '../form/City';
import State from '../form/State';
import Zip from '../form/Zip';
import Phone from '../form/Phone';
import Email from '../form/Email';
import OrganizationType from '../form/OrganizationType';
import Address from '../form/Address';
import { v1 } from 'uuid';
import Address2 from '../form/Address2';
import City2 from '../form/City2';
import State2 from '../form/State2';
import Zip2 from '../form/Zip2';
import Phone2 from '../form/Phone2';
import Email2 from '../form/Email2';
import styled from 'styled-components';
import CountryOfCitizenship from '../form/CountryOfCitizenship';

const ownerInfo = {
  id: v1(),
  firstName: null,
  lastName: null,
  address: null,
  city: null,
  state: null,
  zip: null,
  phone: null,
  email: null,
};

const StyledUpstoContainer = styled.div`
  font-family: 'Open SansVariable';
  font-size: 13px;
  color: #f37217;
`;

const StyledSmsConsent = styled.div`
  .form-check {
    padding-left: 0;
  }
`;

export default function TrademarkStep2({
  state,
  onChange,
  onBlur,
  validated,
  onHandleCoOwners,
}) {
  const bottomRef = React.useRef(null);

  const handleChange = (e) => {
    onChange(e);
  };

  const handleAddOwner = () => {
    const clone = JSON.parse(JSON.stringify(ownerInfo));
    clone.id = v1();
    onHandleCoOwners(state.coOwners.concat(clone));
    bottomRef.current?.scrollIntoView();
  };

  const removeOwner = (event, id) => {
    onHandleCoOwners(state.coOwners.filter((item) => item.id !== id));
  };

  const handleOwnerChange = (event, id) => {
    onHandleCoOwners(
      state.coOwners.map((item) => {
        if (item.id === id && event.target.id) {
          if (event.target.id.includes('firstName'))
            return { ...item, firstName: event.target.value };
          if (event.target.id.includes('lastName'))
            return { ...item, lastName: event.target.value };
          if (event.target.id.includes('address'))
            return { ...item, address: event.target.value };
          if (event.target.id.includes('city'))
            return { ...item, city: event.target.value };
          if (event.target.id.includes('state'))
            return { ...item, state: event.target.value };
          if (event.target.id.includes('zip'))
            return { ...item, zip: event.target.value };
          if (event.target.id.includes('phone')) {
            return { ...item, phone: event.target.value };
          }
          if (event.target.id.includes('email')) {
            return { ...item, email: event.target.value };
          }
          return { ...item, [event.target.id]: event.target.value };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <div className="question step-2">
      <h2>Owner of Trademark Name</h2>
      <Form id="TrademarkForm" noValidate validated={validated}>
        <div className="polaroid">
          <p className="primary-label">
            Will the trademark be owned by an individual or an entity such as a
            corporation or LLC?
          </p>
          <Form.Group controlId="individualOrgOrInd" className="ownerTop">
            <Form.Label>
              Identify the owner of the trademark. This is the person or
              organization who will be the owner of record. If you choose
              individuals, you can enter as many names as you want who own the
              mark. With an organization, you will have to identify someone to
              be the person of contact for the organization.
            </Form.Label>
            <br />

            <Form.Check
              inline
              label="Individual"
              name="individualOrgOrInd"
              type="radio"
              value={'Individual'}
              checked={state.individualOrgOrInd === 'Individual'}
              onChange={handleChange}
              id={`individualOrgOrInd1`}
              data-hj-allow
            />
            <Form.Check
              inline
              label="Organization"
              name="individualOrgOrInd"
              type="radio"
              value={'Organization'}
              checked={state.individualOrgOrInd === 'Organization'}
              onChange={handleChange}
              id={`individualOrgOrInd2`}
              data-hj-allow
            />
          </Form.Group>
        </div>
        <div className="two-column-form">
          {state.individualOrgOrInd === 'Organization' && (
            <div className="polaroid">
              <Form.Group as={Row}>
                <Col sm={12}>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={6}>
                      Formation
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Check
                        inline
                        label="US Based"
                        name="isNonUsBased"
                        type="radio"
                        value={'USBased'}
                        checked={state.isNonUsBased === 'USBased'}
                        onChange={handleChange}
                        id={`isNonUsBased1`}
                        data-hj-allow
                      />
                      <Form.Check
                        inline
                        label="Non US Based"
                        name="isNonUsBased"
                        type="radio"
                        value={'NonUSBased'}
                        checked={state.isNonUsBased === 'NonUSBased'}
                        onChange={handleChange}
                        id={`isNonUsBased2`}
                        data-hj-allow
                      />
                    </Col>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group as={Row} controlId="orgName" className="mb-3">
                    <Form.Label column sm={6} required>
                      Organization Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Organization Name"
                      maxLength="30"
                      value={state.orgName ? state.orgName : ''}
                      onChange={handleChange}
                      pattern="^[ a-zA-Z0-9/-]+$"
                      onKeyPress={(event) => {
                        if (!/[ a-zA-Z0-9/-]/.test(event.key))
                          event.preventDefault();
                      }}
                      required
                      data-hj-allow
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a Organization name
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <OrganizationType
                    id="orgType"
                    label="Organization Type"
                    state={state}
                    onChange={handleChange}
                  />
                </Col>
                <Col sm={6}>
                  {state.isNonUsBased === 'NonUSBased' ? (
                    <CountryOfCitizenship
                      id="formationCountry"
                      label="Country of Formation"
                      value={state.formationCountry}
                      onChange={handleChange}
                    />
                  ) : (
                    <State
                      id="orgState"
                      label="State of Formation"
                      state={state}
                      onChange={handleChange}
                    />
                  )}
                </Col>
                <Col sm={6}>
                  <Form.Group as={Row} controlId="orgPosition" className="mb-3">
                    <Form.Label column sm={6} required>
                      Position
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="CEO"
                      maxLength="30"
                      value={state.orgPosition ? state.orgPosition : ''}
                      onChange={handleChange}
                      pattern="^[ a-zA-Z/-]+$"
                      onKeyPress={(event) => {
                        if (!/[ a-zA-Z/-]/.test(event.key))
                          event.preventDefault();
                      }}
                      required
                      data-hj-allow
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a Position
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Form.Group>
            </div>
          )}
          <div className="polaroid">
            <Form.Group as={Row}>
              <Col sm={6}>
                <FirstName
                  id="firstName"
                  label="First Name"
                  value={state.firstName}
                  onChange={handleChange}
                />
              </Col>
              <Col sm={6}>
                <LastName
                  id="lastName"
                  label="Last Name"
                  value={state.lastName}
                  onChange={handleChange}
                />
              </Col>
              {state.individualOrgOrInd !== 'Organization' && (
                <Col sm={12}>
                  <CountryOfCitizenship
                    id="countryOfCitizenship"
                    label="Country of Citizenship"
                    value={state.countryOfCitizenship}
                    onChange={handleChange}
                  />
                </Col>
              )}
              <Col sm={12}>
                <Address
                  id="address"
                  label="Address"
                  state={state}
                  onChange={handleChange}
                  isNotPO={true}
                />
              </Col>
              <Col sm={6}>
                <City
                  id="city"
                  label="City"
                  state={state}
                  onChange={handleChange}
                />
              </Col>
              <Col sm={6}>
                <State
                  id="state"
                  label="State/Province/Region"
                  state={state}
                  onChange={handleChange}
                />
              </Col>
              <Col sm={6}>
                <Zip
                  id="zip"
                  label="Zip/Postal Code"
                  state={state}
                  onChange={handleChange}
                />
              </Col>
              <Col sm={6}>
                <Phone
                  id="phone"
                  label="Phone"
                  state={state}
                  onChange={handleChange}
                />
                <StyledSmsConsent>
                  <Form.Check
                    type="checkbox"
                    label="I consent to receiving SMS text messages regarding my order from Trademark Genius."
                    name="consentToGetSMS"
                    checked={state.consentToGetSMS === true}
                    onChange={handleChange}
                    id="consentToGetSMS"
                  />
                </StyledSmsConsent>
              </Col>
              <Col sm={12}>
                <Email
                  id="email"
                  label="Email"
                  state={state}
                  onChange={handleChange}
                  onBlur={onBlur}
                />
              </Col>
              <Col sm={12}>
                <StyledUpstoContainer>
                  * The USPTO only accepts valid physical addresses. PO boxes
                  are not accepted.
                </StyledUpstoContainer>
              </Col>
            </Form.Group>
          </div>
          {state.individualOrgOrInd === 'Individual' && state.coOwners
            ? state.coOwners.map((owner) => (
                <div key={owner.id} style={{ width: '100%' }}>
                  <div className="polaroid">
                    <Form.Group as={Row} key={owner.id}>
                      <Col sm={6}>
                        <FirstName
                          id={owner.id + '_firstName'}
                          label="First Name"
                          value={owner.firstName}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={6}>
                        <LastName
                          id={owner.id + '_lastName'}
                          label="Last Name"
                          value={owner.lastName}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={12}>
                        <Address2
                          id={owner.id + '_address'}
                          label="Address"
                          value={owner.address}
                          onChange={() => handleOwnerChange(event, owner.id)}
                          isNotPO={true}
                        />
                      </Col>
                      <Col sm={6}>
                        <City2
                          id={owner.id + '_city'}
                          label="City"
                          value={owner.city}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={6}>
                        <State2
                          id={owner.id + '_state'}
                          label="State/Province/Region"
                          value={owner.state}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={6}>
                        <Zip2
                          id={owner.id + '_zip'}
                          label="Zip/Postal Code"
                          value={owner.zip}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={6}>
                        <Phone2
                          id={owner.id + '_phone'}
                          label="Phone"
                          value={owner.phone}
                          onChange={() => handleOwnerChange(event, owner.id)}
                        />
                      </Col>
                      <Col sm={12}>
                        <Email2
                          id={owner.id + 'email'}
                          label="Email"
                          value={owner.email}
                          onChange={() => handleOwnerChange(event, owner.id)}
                          onBlur={onBlur}
                          verifying={state.verifying}
                          verificationResult={state.verificationResult}
                        />
                      </Col>
                    </Form.Group>
                    <div className="row" style={{ display: 'inline' }}>
                      <Button
                        className="addOwner remove"
                        variant="contained"
                        onClick={() => removeOwner(event, owner.id)}
                      >
                        - remove owner
                      </Button>
                    </div>
                  </div>
                </div>
              ))
            : null}
          {state.individualOrgOrInd === 'Individual' ? (
            <div className="row" style={{ display: 'inline' }}>
              <Button
                className="addOwner"
                variant="contained"
                onClick={handleAddOwner}
              >
                + Add owner
              </Button>
            </div>
          ) : null}
          <div ref={bottomRef} />
        </div>
      </Form>
    </div>
  );
}
